import { createSlice } from "@reduxjs/toolkit";

const createResourceState = () => ({
  data: null,
  isLoading: false,
  error: null,
  success: null,
});

const initialState = {
  farms: createResourceState(),
  farm: createResourceState(),
  livestock: createResourceState(),
  livestockItem: createResourceState(),
  livestockSurveys: createResourceState(),
  livestockProcessingMethods: createResourceState(),
  livestockMeasurements: createResourceState(),
  livestockDigitalTwin: createResourceState(),
  livestockDigitalTwins: createResourceState(),
};

const setLoading = (state, resourceKey) => {
  state[resourceKey].isLoading = true;
  state[resourceKey].error = null;
  state[resourceKey].success = false;
};

const setSuccess = (state, resourceKey, payload) => {
  state[resourceKey].isLoading = false;
  state[resourceKey].data = payload;
  state[resourceKey].success = true;
};

const setFailure = (state, resourceKey, payload) => {
  state[resourceKey].isLoading = false;
  state[resourceKey].error = payload;
  state[resourceKey].success = false;
};

const farmsSlice = createSlice({
  name: "farms",
  initialState,
  reducers: {
    fetchFarmsStart(state) {
      setLoading(state, "farms");
    },
    fetchFarmsSuccess(state, action) {
      setSuccess(state, "farms", action.payload);
    },
    fetchFarmsFailure(state, action) {
      setFailure(state, "farms", action.payload);
    },

    fetchFarmByIdStart(state) {
      setLoading(state, "farm");
    },
    fetchFarmByIdSuccess(state, action) {
      setSuccess(state, "farm", action.payload);
    },
    fetchFarmByIdFailure(state, action) {
      setFailure(state, "farm", action.payload);
    },

    fetchLivestockStart(state) {
      setLoading(state, "livestock");
    },
    fetchLivestockSuccess(state, action) {
      setSuccess(state, "livestock", action.payload);
    },
    fetchLivestockFailure(state, action) {
      setFailure(state, "livestock", action.payload);
    },

    fetchLivestockByIdStart(state) {
      setLoading(state, "livestockItem");
    },
    fetchLivestockByIdSuccess(state, action) {
      setSuccess(state, "livestockItem", action.payload);
    },
    fetchLivestockByIdFailure(state, action) {
      setFailure(state, "livestockItem", action.payload);
    },

    fetchLivestockSurveysStart(state) {
      setLoading(state, "livestockSurveys");
    },
    fetchLivestockSurveysSuccess(state, action) {
      setSuccess(state, "livestockSurveys", action.payload);
    },
    fetchLivestockSurveysFailure(state, action) {
      setFailure(state, "livestockSurveys", action.payload);
    },

    fetchLivestockProcessingMethodsStart(state) {
      setLoading(state, "livestockProcessingMethods");
    },
    fetchLivestockProcessingMethodsSuccess(state, action) {
      setSuccess(state, "livestockProcessingMethods", action.payload);
    },
    fetchLivestockProcessingMethodsFailure(state, action) {
      setFailure(state, "livestockProcessingMethods", action.payload);
    },

    fetchLivestockMeasurementsStart(state) {
      setLoading(state, "livestockMeasurements");
    },
    fetchLivestockMeasurementsSuccess(state, action) {
      setSuccess(state, "livestockMeasurements", action.payload);
    },
    fetchLivestockMeasurementsFailure(state, action) {
      setFailure(state, "livestockMeasurements", action.payload);
    },

    fetchLivestockDigitalTwinStart(state) {
      setLoading(state, "livestockDigitalTwin");
    },
    fetchLivestockDigitalTwinSuccess(state, action) {
      setSuccess(state, "livestockDigitalTwin", action.payload);
    },
    fetchLivestockDigitalTwinFailure(state, action) {
      setFailure(state, "livestockDigitalTwin", action.payload);
    },

    fetchLivestockDigitalTwinsStart(state) {
      setLoading(state, "livestockDigitalTwins");
    },
    fetchLivestockDigitalTwinsSuccess(state, action) {
      setSuccess(state, "livestockDigitalTwins", action.payload);
    },
    fetchLivestockDigitalTwinsFailure(state, action) {
      setFailure(state, "livestockDigitalTwins", action.payload);
    },
  },
});

export const {
  fetchFarmsStart,
  fetchFarmsSuccess,
  fetchFarmsFailure,
  fetchFarmByIdStart,
  fetchFarmByIdSuccess,
  fetchFarmByIdFailure,
  fetchLivestockStart,
  fetchLivestockSuccess,
  fetchLivestockFailure,
  fetchLivestockByIdStart,
  fetchLivestockByIdSuccess,
  fetchLivestockByIdFailure,
  fetchLivestockSurveysStart,
  fetchLivestockSurveysSuccess,
  fetchLivestockSurveysFailure,
  fetchLivestockProcessingMethodsStart,
  fetchLivestockProcessingMethodsSuccess,
  fetchLivestockProcessingMethodsFailure,
  fetchLivestockMeasurementsStart,
  fetchLivestockMeasurementsSuccess,
  fetchLivestockMeasurementsFailure,
  fetchLivestockDigitalTwinStart,
  fetchLivestockDigitalTwinSuccess,
  fetchLivestockDigitalTwinFailure,
  fetchLivestockDigitalTwinsStart,
  fetchLivestockDigitalTwinsSuccess,
  fetchLivestockDigitalTwinsFailure,
} = farmsSlice.actions;

export default farmsSlice.reducer;
